import { render } from "./CurrentlyReadingBookList.vue?vue&type=template&id=045c2950&scoped=true"
import script from "./CurrentlyReadingBookList.vue?vue&type=script&lang=js"
export * from "./CurrentlyReadingBookList.vue?vue&type=script&lang=js"

import "./CurrentlyReadingBookList.vue?vue&type=style&index=0&id=045c2950&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045c2950"]])

export default __exports__